import { render } from "./OpenHoursForm.vue?vue&type=template&id=5838762b"
import script from "./OpenHoursForm.vue?vue&type=script&lang=js"
export * from "./OpenHoursForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__